import React from 'react';
import { useSocket } from '../contexts/SocketContext';
import { getRunTier } from '../utils/runTiers';

export function getHistoryTier(crashPoint: number) {
  return `pill pill-${getRunTier(crashPoint).id}`;
}

const GameHistory: React.FC = () => {
  const { gameInfo } = useSocket();
  // Newest run on the left, read left to right; order by round number so it never depends on how the server sent them.
  const history = gameInfo?.history.slice().sort((a, b) => b.id - a.id) ?? [];

  return (
    <div className="history-content">
      <span className="history-title">Recent runs</span>
      {history.length === 0 ? (
        <span className="history-title">Waiting for the first result…</span>
      ) : (
        <div className="history-list" aria-label="Recent crash multipliers">
          {history.map(game => (
            <span key={game.id} className={getHistoryTier(game.crashPoint)}>{game.crashPoint.toFixed(2)}x</span>
          ))}
        </div>
      )}
    </div>
  );
};

export default GameHistory;
